import { ReactNode, createContext, useState } from "react";
import { Account } from "@models/account";

interface AccountContextType {
  account: Account | null;
  setAccount: (account: Account) => void;
}

export const AccountContext = createContext<AccountContextType>({
  account: null,
  setAccount: () => {},
});

export const AccountProvider: React.FC<{ children: ReactNode; account: Account }> = ({
  children,
  account,
}) => {
  const [currentAccount, setCurrentAccount] = useState<Account>(account);

  return (
    <AccountContext.Provider value={{ account: currentAccount, setAccount: setCurrentAccount }}>
      {children}
    </AccountContext.Provider>
  );
};
